import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/footer";
import PageSectionsRenderer from "../../components/common/PageSectionsRenderer";

const Terms = () => {
  return (
    <div className="bg-slate-50 min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="bg-blue-900 text-white py-20 px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Terms & Conditions</h1>
          <p className="text-xl opacity-90">
            Rules and guidelines for using our platform and participating in events.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="prose max-w-none text-slate-600">
              <p className="text-sm text-slate-500 mb-8">Last updated: February 18, 2026</p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Acceptance of Terms</h2>
              <p className="mb-6">
                By accessing and using the Para Sports Association of Andhra Pradesh website and services,
                you accept and agree to be bound by the terms and provision of this agreement.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Event Participation</h2>
              <p className="mb-6">
                Participants in Para sports events must:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>Meet the eligibility criteria for their respective disability category</li>
                <li>Provide accurate medical and classification information</li>
                <li>Comply with all safety and conduct guidelines</li>
                <li>Accept the decisions of event officials and classifiers</li>
                <li>Respect fellow participants, officials, and volunteers</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Registration and Fees</h2>
              <p className="mb-6">
                Registration fees are non-refundable except in cases of event cancellation by the association.
                Participants are responsible for ensuring their registration information is accurate and complete.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Medical and Safety</h2>
              <p className="mb-6">
                Participants acknowledge that Para sports involve inherent risks. The association takes all
                reasonable measures to ensure safety, but participants are responsible for their own health
                and should consult medical professionals before participating.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Code of Conduct</h2>
              <p className="mb-6">
                All participants, coaches, and supporters must maintain the highest standards of sportsmanship
                and conduct. Any form of discrimination, harassment, or unsportsmanlike behavior will result
                in disqualification and potential banning from future events.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Intellectual Property</h2>
              <p className="mb-6">
                All content on this website, including logos, images, and text, is the property of the
                Para Sports Association of Andhra Pradesh unless otherwise stated. Unauthorized use is prohibited.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Limitation of Liability</h2>
              <p className="mb-6">
                The association shall not be liable for any direct, indirect, incidental, or consequential
                damages arising from the use of our services or participation in events.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Contact Information</h2>
              <p className="mb-6">
                For questions about these terms, please contact us at:
              </p>
              <div className="bg-slate-50 p-4 rounded-lg">
                <p><strong>Email:</strong> info@parasportsap.org</p>
                <p><strong>Phone:</strong> +91-XXXXXXXXXX</p>
                <p><strong>Address:</strong> Para Sports Association of Andhra Pradesh</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PageSectionsRenderer pageKey="terms" className="pt-0" />

      <Footer />
    </div>
  );
};

export default Terms;
